<template>
  <div :class="['calc-item', { 'calc-item-mob': isMobile, balloon: balloon }]">
    <el-row
      type="flex"
      :justify="isMobile ? '' : 'space-between'"
      class="calc-top"
    >
      <div>
        <b>
          {{ dateToFormat(item[config.date], 'onlyDateWithShortYear') }}
        </b>
      </div>
      <div class="ta-c">
        <b>{{ item.distance }} км</b>
      </div>
      <div class="ta-c">
        <b>{{ item.price }} руб/кг ({{ getCoeff(item) }})</b>
      </div>
      <div class="calc-last">
        <b v-if="config.own">
          {{ item.total_responses }} авто из {{ item.cars_count }}
        </b>
        <template v-else>
          <span class="count-view">
            <i class="el-icon-view" />
            {{ item.view_count }}
          </span>
          <span>отв {{ item.answers_count }}</span>
        </template>
      </div>
    </el-row>
    <el-row class="distance">
      <p>{{ item[config.load] }}</p>
      <p>{{ item[config.unload] }}</p>
    </el-row>
    <p class="same">
      <template v-if="!config.own">
        {{ getSame(item.same_count) }}
      </template>
    </p>
  </div>
</template>

<script>
import { pluralNew, roundUp } from '@/helpers/functions'

export default {
  name: 'ResultsItem',
  props: {
    item: {
      type: Object,
      default: () => {},
    },
    config: {
      type: Object,
      default: () => {},
    },
    balloon: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getSame(n) {
      const arr = ['одинаковая', 'одинаковые', 'одинакавых']

      return pluralNew(n, arr)
    },
    getCoeff(item) {
      return roundUp((item.price * 1000) / item.distance)
    },
  },
}
</script>

<style lang="sass">
.calc-item
  background: #F7F7F7
  border: 1px solid #D1D1D1
  border-radius: 5px
  margin-bottom: 25px
  margin-right: 20px
  padding: 20px 30px 15px 70px
  min-height: 150px
  box-sizing: border-box
  span, b
    margin-right: 10px
  span
    color: #ACACAC
  .calc-last
    text-align: right
  .distance
    margin-top: 15px
    position: relative
    &:before
      content: ''
      position: absolute
      left: -65px
      top: 20px
      background: url(/img/arrow-route.9123c786.svg) no-repeat
      background-size: contain
      transform: rotate(90deg)
      width: 60px
      height: 25px
    p
      margin: 10px 0 0
  .same
    color: #A9A9A9
    margin: 10px 0 0
  .count-view
    margin-right: 10px
    &>i
      margin-right: 5px
  &.calc-item-mob
    padding: 20px 20px 15px 40px
    margin-right: 0
    border-left: 0
    border-right: 0
    border-radius: 0
    .calc-top
      flex-wrap: wrap
      .calc-last
        width: 100%
        margin-top: 10px
    .distance:before
      left: -50px
      width: 50px
      height: 20px
  &.balloon
    background: none
    border: 0
    padding: 15px
    min-height: inherit
    margin: 0
    .calc-last
      width: auto
      margin-top: 0
    .distance
      margin-top: 5px
      &:before
        display: none
      p
        margin: 0
    .same
      margin-top: 5px
</style>
